import request from '@/utils/request'
export function page (query) {
    return request({
        url: '/fms/suggestion/page',
        method: 'get',
        params: query
    })
}
export function create (data) {
    return request({
        url: '/fms/suggestion/create',
        method: 'post',
        data: data,
    })
}
export function updateFile (data) {
    return request({
        url: '/fms/suggestion/upload',
        method: 'post',
        data: data,
    })
}
export function update (data) {
    return request({
        url: '/fms/suggestion/update',
        method: 'post',
        data: data,
    })
}
export function deleteById (id) {
    return request({
        url: '/fms/suggestion/deleteById',
        method: 'get',
        params: { id: id }
    })
}
export function deleteByIds (ids) {
    return request({
        url: '/fms/suggestion/deleteByIds',
        method: 'get',
        params: { ids: ids }
    })
}
export function getById (id) {
    return request({
        url: '/fms/suggestion/getById',
        method: 'get',
        params: { id: id }
    })
}
//上传文件
export function uploadFile (data, config) {
    return request({
        url: '/fms/file/sugg',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        ...config
    })
}



export function downloadFile (data) {
    return request({
        url: '/fms/suggestion/genWord',
        method: 'post',
        data: data,
        responseType: 'blob',
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export function batchDownloadFile (data) {
    return request({
        url: '/fms/suggestion/batchDownloadFile',
        method: 'post',
        data: data,
        responseType: 'blob',
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}